import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const TOMOS = [{
  number: '1',
  title: 'El Cimiento del Diagnóstico: Descubre la Verdadera Causa de la Maloclusión',
  lead: 'Deja de tratar únicamente los síntomas.',
  body: 'Aprende a identificar si el origen del problema es óseo, muscular o dental para tomar decisiones clínicas correctas desde la primera evaluación y evitar tratamientos que no atacan la causa real.'
}, {
  number: '2',
  title: 'La Cara Nunca Miente: Domina el Análisis Facial que Define el Tratamiento',
  lead: 'Aprende a interpretar el rostro de tu paciente como un mapa diagnóstico.',
  body: 'Identifica el biotipo facial y comprende qué tratamientos tienen mayor probabilidad de éxito antes de elegir cualquier aparato.'
}, {
  number: '3',
  title: 'El Motor Oculto del Éxito: Corrige las Funciones que Hacen Fracasar los Tratamientos',
  lead: 'Descubre cómo la respiración, la deglución y la masticación pueden estar manteniendo la maloclusión.',
  body: 'Detecta los hábitos que sabotean los resultados y evita que el tratamiento recaiga incluso utilizando el aparato correcto.'
}, {
  number: '4',
  title: 'La Matriz de Decisión Clínica: Convierte Casos Complejos en Diagnósticos Claros',
  lead: 'Deja de improvisar frente a cada paciente.',
  body: 'Utiliza un sistema de clasificación clínica que organiza cada maloclusión y te guía paso a paso hacia la estrategia terapéutica más adecuada con mayor confianza.'
}, {
  number: '5',
  title: 'El Selector Maestro de Aparatología: Elige el Aparato Correcto con Total Seguridad',
  lead: 'Elimina las dudas al momento de indicar un tratamiento.',
  body: 'Aprende cuándo utilizar cada aparato funcional y comprende el razonamiento clínico detrás de cada elección para obtener resultados más predecibles.'
}, {
  number: '6',
  title: 'Seguridad Clínica Total: Presenta tu Diagnóstico con la Confianza de un Especialista',
  lead: 'Explica el diagnóstico y el plan de tratamiento con claridad y autoridad.',
  body: 'Genera mayor confianza en los padres, reduce las objeciones y consigue que acepten el tratamiento con la tranquilidad de estar tomando la mejor decisión para su hijo.'
}];
export function Tomos() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-268" data-mp="24y2zgxhpy8mf">
      <div className="mx-auto w-full max-w-3xl" data-id="element-269" data-mp="2iy3w20qyatw3">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-270" data-mp="2iwsxqgg9yecd">
          ¿Qué encontrarás dentro del Sistema OFM?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ofm-900/70 sm:text-lg" data-id="element-271" data-mp="2sn42243vepjs">
          No es otro libro de ortopedia funcional. Es un sistema de decisión clínica
          que te acompaña desde la primera observación del paciente hasta la
          elección del aparato más adecuado.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-center text-[14px] leading-relaxed text-ofm-900/60" data-id="element-272" data-mp="2xlozxwvngx52">
          Cada tomo resuelve una etapa crítica del proceso diagnóstico para que
          nunca tengas que improvisar frente a un caso infantil.
        </p>

        <div className="mt-9 space-y-4" data-id="element-273" data-mp="37acet9ctv2xv">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="rounded-2xl border border-ofm-100 bg-cream p-5 shadow-sm sm:p-6" data-id="element-274" data-mp="3c9fnd3s0nral" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-275" data-mp="2tjqx3nz40z1k">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ofm-600 font-display text-lg font-bold text-white" data-id="element-276" data-mp="2tk8wuukzdve8">
                  {tomo.number}
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-ofm-600" data-id="element-277" data-mp="2jkruon4xtzn0">
                  📘 Tomo {tomo.number}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[19px] font-bold leading-snug text-ofm-900 sm:text-2xl" data-id="element-278" data-mp="3hyp4kooujmxz">
                {tomo.title}
              </h3>
              <p className="mt-2.5 text-[14px] font-semibold leading-snug text-ofm-700 sm:text-[15px]" data-id="element-279" data-mp="387uc32l0br43">
                {tomo.lead}
              </p>
              <p className="mt-1.5 text-[14px] leading-relaxed text-ofm-900/70 sm:text-[15px]" data-id="element-280" data-mp="33a18mhb39b7i">
                {tomo.body}
              </p>
            </motion.article>)}
        </div>

        <CTAButton className="mt-9" label="🦷 QUIERO LOS 6 TOMOS AHORA" subline="Los 6 tomos completos por solo $12.99 USD" data-id="element-281" data-mp="2u8bhlcl4cea9" />
      </div>
    </section>;
}